// Dollars and dates for the receipts screens. null is unknown and shows as
// an em dash, never $0.
export function usd(n) {
  if (typeof n !== 'number' || !Number.isFinite(n)) return '—';
  return `${n < 0 ? '−' : ''}$${Math.abs(n).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
}

const DOW = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
const MON = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
const parts = (ymd) => (/^\d{4}-\d{2}-\d{2}$/.test(String(ymd || '')) ? ymd.split('-').map(Number) : null);

/** "Sat, Oct 10, 2026" */
export function longDate(ymd) {
  const p = parts(ymd);
  if (!p) return null;
  const dt = new Date(Date.UTC(p[0], p[1] - 1, p[2]));
  return `${DOW[dt.getUTCDay()]}, ${MON[p[1] - 1]} ${p[2]}, ${p[0]}`;
}
/** "Oct 10" */
export function shortDate(ymd) {
  const p = parts(ymd);
  return p ? `${MON[p[1] - 1]} ${p[2]}` : 'date not read';
}
/** "2026-10" -> "Oct" (with the year when it is not `year`) */
export function monthLabel(ym, year = null) {
  const [y, m] = String(ym).split('-').map(Number);
  return `${MON[m - 1]}${year && y !== year ? ` '${String(y).slice(2)}` : ''}`;
}
